import { FormikToggleField } from 'components/FormikToggleField/FormikToggleField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface RespectSystemProxyConfigurationValues {
  respectSystemProxyConfiguration: boolean;
}

interface Props<T extends RespectSystemProxyConfigurationValues> {
  formik: FormikProps<T>;
}

export const FormikVendorApiRespectSystemProxyConfigurationField = <
  T extends RespectSystemProxyConfigurationValues,
>(
  props: Props<T>,
): JSX.Element => {
  const {
    discoverySettings: {
      vendorsApi: { labels: labelsMsg },
    },
  } = useLocale();
  return (
    <FormikToggleField
      className='mb-4'
      formik={props.formik}
      name='respectSystemProxyConfiguration'
      label={labelsMsg.respectSystemProxyConfiguration}
      labelPosition='right'
      hideStateMessage
    />
  );
};
